import { render, staticRenderFns } from "./carousel_loading.vue?vue&type=template&id=60f53382&scoped=true"
import script from "./carousel_loading.vue?vue&type=script&lang=js"
export * from "./carousel_loading.vue?vue&type=script&lang=js"
import style0 from "./carousel_loading.vue?vue&type=style&index=0&id=60f53382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f53382",
  null
  
)

export default component.exports